import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { StockUtils } from '@frame/StockUtils'
import { useRemoteConfig } from 'hooks/useRemoteConfigStore'
import { ErpTemple } from '@ca/common'

type TempleId = string | number

type TempleListItem = {
  id: TempleId
  qty?: number
  store_qty?: number | null
  plc?: string
}

type FrameCheckParams = {
  temple: TempleListItem
  isChecked?: boolean
  isSearchScreen?: boolean
  isSaved?: boolean
}

export function useTempleSelectionUI({
  temple,
  isChecked,
  isSaved,
  isSearchScreen,
}: FrameCheckParams) {
  const { t } = useTranslation(['status'])

  const config = useRemoteConfig()

  const isAvailable = useMemo(() => {
    if (!temple) return false

    return StockUtils.isAvailable(temple as ErpTemple, config?.region)
  }, [temple, config?.region])

  const variant = useMemo(() => {
    if (isChecked) return 'active' as const

    if (!isAvailable) {
      if (isSearchScreen) return 'danger' as const
      return 'disabled' as const
    }
    if (isSaved) return 'success' as const
    return 'default' as const
  }, [isChecked, isSearchScreen, isSaved, temple.store_qty])

  const badge = useMemo(() => {
    if (!isAvailable) {
      return { text: t('status:frame.out'), variant: 'danger' as const }
    }
    if (isSaved)
      return { text: t('status:frame.saved'), variant: 'success' as const }
    // if (qty < 10)
    //   return { text: t('status:frame.limited'), variant: 'warning' as const }
    return undefined
  }, [t, isSaved, isAvailable])

  return {
    variant,
    badge,
  }
}
